module.exports = __webpack_public_path__ + "img/eraser-1.9b0bc6d8.svg";